import { render } from "./BlockGeneric.vue?vue&type=template&id=18d331e8"
import script from "./BlockGeneric.vue?vue&type=script&lang=js"
export * from "./BlockGeneric.vue?vue&type=script&lang=js"

import "./BlockGeneric.vue?vue&type=style&index=0&id=18d331e8&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__